function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LookNews_fun, imageUploads_fun_s, codeTypeList, imageUploads_dellp, excleCargoDownload_biaodi } from '@/api/policymanagement';
import { claimReportApplyQueryList, claimReportApplyLossQuery, rinkoClaimPersonQuery, rinkoClaimReportApplySubmit, rinkoClaimLook, rinkoImageUploads, rinkoImageView, rinkoImageDel } from '@/api/rinko';
import { validateEmail2, checkPhone } from '../../libs/common';
import $ from 'jquery';
import { getProvinceCityArea } from '@/api/baseDate';
import List_obj from "../protocol/list_obj";
export default {
  name: 'claimApply',
  data: function data() {
    var _this = this,
        _ref;

    var checkAge = function checkAge(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入报案人电话'));
      } else if (checkPhone(value) == false) {
        return callback(new Error('请输入正确的电话号码'));
      } else {
        return callback();
      }
    };

    var checkCountryName = function checkCountryName(rule, value, callback) {
      if (_this.inForm.nationType == '2') {
        if (!_this.flag) {
          if (value == '' || value == undefined) {
            return callback(new Error('请选择国家'));
          } else {
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };

    var checkProvinceName = function checkProvinceName(rule, value, callback) {
      if (_this.inForm.nationType == '1') {
        if (!_this.flag) {
          if (value == '' || value == undefined) {
            return callback(new Error('请选择省'));
          } else {
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };

    var checkCityName = function checkCityName(rule, value, callback) {
      if (_this.inForm.nationType == '1') {
        if (!_this.flag) {
          if (value == '' || value == undefined) {
            return callback(new Error('请选择市'));
          } else {
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };

    var checkAreaName = function checkAreaName(rule, value, callback) {
      if (_this.inForm.nationType == '1') {
        if (!_this.flag) {
          if (value == '' || value == undefined) {
            return callback(new Error('请选择区'));
          } else {
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };

    var checkBge = function checkBge(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入报案人邮箱'));
      } else if (validateEmail2(value) == false) {
        return callback(new Error('请输入正确的邮箱号码'));
      } else {
        return callback();
      }
    };

    var validatePass1 = function validatePass1(rule, value, callback) {
      if (!_this.inForm.reportDate) {
        return callback(new Error('请录入报案出险时间'));
      } else {
        return callback();
      }
    };

    var validatePass2 = function validatePass2(rule, value, callback) {
      if (!_this.inForm.damageDate) {
        return callback(new Error('请录入出险时间'));
      } else {
        return callback();
      }
    };

    return _ref = {
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      loing_box: true,
      upimgsNum: 0,
      proposalNo: '',
      comeFlag: '',
      getTips: '',
      isUpimg: false,
      isUpimg2: false,
      rtnclaimCode: '',
      from: 0,
      claimCode: '',
      damagedItem: '',
      isView: false,
      isNotView: true,
      dialogVisible: false,
      dialogImageUrl: '',
      currentPage3: '',
      tableData1: [],
      tableData2: [],
      options: [{
        value: '1',
        label: '1'
      }],
      inForm: {
        policyNo: '',
        acciReason: '',
        damageAddress: '',
        damageDate: '',
        reportDate: '',
        reportEmail: '',
        reportMethodCode: '00',
        reportMethodName: '其他',
        reportName: '',
        damagedItem: '',
        reportPhone: '',
        claimCode: '',
        countryName: '',
        countryEName: '',
        provinceCode: '',
        provinceName: '',
        currencyCode: '',
        currencyName: '',
        cityCode: '',
        cityName: '',
        areaCode: '',
        areaName: '',
        detailAddress: '',
        nationalFlag: '',
        nationType: '',
        nationalFlagName: '',
        personHurtInfo: []
      },
      rules: {
        damageDate: [{
          required: true,
          validator: validatePass2,
          trigger: 'change'
        }],
        reportPhone: [{
          required: true,
          trigger: 'change',
          validator: checkAge
        }],
        countryEName: [{
          required: true,
          trigger: 'change',
          validator: checkCountryName
        }],
        provinceName: [{
          required: true,
          trigger: 'change',
          validator: checkProvinceName
        }],
        cityName: [{
          required: true,
          trigger: 'change',
          validator: checkCityName
        }],
        areaName: [{
          required: true,
          trigger: 'change',
          validator: checkAreaName
        }],
        reportName: [{
          required: true,
          message: '请输入报案人姓名',
          trigger: 'change'
        }, {
          pattern: /^[A-Za-z\u4e00-\u9fa5]+$/,
          message: '报案人姓名格式不正确'
        }],
        acciReason: [{
          required: true,
          message: '请选择出险原因',
          trigger: 'blur'
        }],
        reportEmail: [{
          required: true,
          message: '请输入电子邮箱',
          trigger: 'blur'
        }, {
          pattern: /^((([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6}\,))*(([a-zA-Z0-9_\.-]+)@([\da-zA-Z\.-]+)\.([a-zA-Z\.]{2,6})))$/,
          message: '电子邮箱格式不正确'
        }],
        damageAddress: [{
          required: true,
          message: '请输入出险经过描述',
          trigger: 'change'
        }]
      },
      options_reportMethod: [{
        reportMethodCode: '00',
        reportMethodName: '其他'
      }],
      options_acciReason: [],
      total: 0,
      fileList: [],
      fileList1: [],
      fileListZ: [],
      fileListF: {
        imagUse: '',
        imagUseType: '',
        name: '',
        imagUseName: ''
      }
    }, _defineProperty(_ref, "dialogImageUrl", ""), _defineProperty(_ref, "isSave", false), _defineProperty(_ref, "isList1", false), _defineProperty(_ref, "nationFlag", false), _defineProperty(_ref, "imageShowFlag", true), _defineProperty(_ref, "codeFlag", true), _defineProperty(_ref, "nation", List_obj.nationalType), _defineProperty(_ref, "countryAllList", []), _defineProperty(_ref, "countryList", []), _defineProperty(_ref, "provinceList", []), _defineProperty(_ref, "cityList", []), _defineProperty(_ref, "areaList", []), _defineProperty(_ref, "allAddressData", []), _defineProperty(_ref, "showFlag", true), _defineProperty(_ref, "chinaList", []), _defineProperty(_ref, "flag", false), _defineProperty(_ref, "nationType", '1'), _defineProperty(_ref, "viewShowFlag", false), _defineProperty(_ref, "type", ''), _defineProperty(_ref, "currencyList", []), _ref;
  },
  destroyed: function destroyed() {},
  mounted: function mounted() {
    var _this2 = this;

    this.isView = this.$route.params.type != 'edit';
    this.type = this.$route.params.type;
    this.comeFlag = this.$route.params.flag ? this.$route.params.flag : '';
    this.proposalNo = this.$route.params.proposalNo ? this.$route.params.proposalNo : ''; // this.claimCode = this.$route.params.claimCode ? this.$route.params.claimCode : ''

    debugger;
    var data = this.$route.params.policyNo;
    var dataType = this.$route.params.type;
    console.log(this.comeFlag, ',,,,,,,,,,,,,,,,,,,,,,,,');
    debugger;
    this.Init_get(data);
    this.codeTypeList_fun();
    this.getProvinceCityData(); // this.add_personHurt()

    debugger;
    rinkoClaimLook({
      'policyNo': data
    }).then(function (res) {
      if (res.rinkoImageList != null) {
        debugger;
        _this2.upimgsNum = res.rinkoImageList.length;

        for (var i = 0; i < res.rinkoImageList.length; i++) {
          var obj = {};
          var formData = new FormData();
          var base64 = 'data:image/png;base64,' + res.rinkoImageList[i].base64;
          var base64url = res.rinkoImageList[i].base64;
          var imagCode = res.rinkoImageList[i].imagCode;
          var proposalNo = res.rinkoImageList[i].proposalNo;
          var claimCode = res.rinkoImageList[i].claimCode;
          var fileSrc = res.rinkoImageList[i].imagUrl;
          var fileName = res.rinkoImageList[i].fileName;
          var imagUseType = res.rinkoImageList[i].imagUseType; // 转换base64到file

          var toFile = require('data-uri-to-file');

          toFile(base64).then(function (filed) {
            formData.append("imageName", filed);
            obj.raw = filed;
          });
          obj['type'] = 'old';
          obj['url'] = base64;
          obj.imagCode = imagCode;
          obj.proposalNo = proposalNo;
          obj.claimCode = claimCode;
          obj.base64url = base64url;
          obj.fileSrc = fileSrc;
          obj.name = fileName;

          if (imagUseType == '10') {
            _this2.fileList1.push(obj);
          }
        }
      }
    });
  },
  methods: {
    // 清楚提示
    clearValidate: function clearValidate(formName) {
      this.$refs[formName].clearValidate();
    },
    // 获取时间戳
    getTimes: function getTimes(time) {
      // console.log(this.ruleForm.businessStartDate)
      var timestamp = Date.parse(new Date(time));
      return timestamp;
    },
    inputs: function inputs(data, index) {
      var _this3 = this;

      var a = 0;
      console.log(data, index);
      console.log(this.tableData2);

      for (var i in this.tableData2) {
        a = this.tableData2[i].lossaMount * 1 + a;
      }

      var ragu = /^([1-9]\d*|0)(\.\d{1,4})?$/;

      if (data.lossQuantity * 1) {
        if (ragu.test(parseFloat(data.lossQuantity)) == false) {
          this.$alert('<p>受损数量最多可支持录入四位小数</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this3.tableData2[index].lossQuantity = parseFloat(data.lossQuantity).toFixed(4);
            }
          });
        }
      }

      if (data.lossaMount * 1) {
        if (ragu.test(parseFloat(data.lossaMount)) == false) {
          this.$alert('<p>预计损失金额最多可支持录入四位小数</p>', '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            callback: function callback(action) {
              _this3.tableData2[index].lossaMount = parseFloat(data.lossaMount).toFixed(4);
            }
          });
        }
      }

      if (data.lossQuantity * 1 > data.quantity * 1) {
        this.tableData2[index].lossQuantity = this.tableData2[index].quantity;
      }

      if (data.lossaMount * 1 > data.totalAmount * 1) {
        this.tableData2[index].lossaMount = this.tableData2[index].totalAmount;
      } //预计损失金额小于1万元，且赔付币种选择了人民币


      if (a < 10000 && data.compensateCurrencyCode == 'CNY') {
        this.imageShowFlag = false;
      } //预计损失金额小于1万元，且赔付币种选择了人民币


      if (a > 10000 && data.compensateCurrencyCode == 'CNY') {
        this.imageShowFlag = true;
      } //预计损失金额为null时


      if (data.lossaMount == null || data.lossaMount == '') {
        this.imageShowFlag = true;
      }
    },
    //初始化
    Init_get: function Init_get(policyNo) {
      var _this4 = this;

      var flag = this.$route.params.flag;
      var typeType = this.$route.params.type;

      if (undefined != typeType && null != typeType) {
        if ('view' === typeType) {
          this.isView = true; //初始化报案信息和损失信息

          var cliamCodeDate = {
            'claimCode': this.$route.params.claimCode
          };
          claimReportApplyLossQuery(cliamCodeDate).then(function (res) {
            if (res != null) {
              for (var i = 0; i < res.length; i++) {
                if (res[i].nationalFlag == '2') {
                  _this4.showFlag = false;
                  debugger;
                  _this4.inForm.countryEName = res[i].countryEname;
                  _this4.inForm.countryName = res[i].countryName;
                  _this4.inForm.nationType = res[i].nationalFlag;
                  _this4.inForm.nationalFlagName = res[i].nationalFlagName;
                } else {
                  _this4.inForm.nationType = '1';
                  _this4.inForm.nationalFlagName = res[i].nationalFlagName;
                  _this4.inForm.countryEName = res[i].countryEname;
                  _this4.inForm.countryName = res[i].countryName;
                  _this4.inForm.provinceCode = res[i].provinceCode;
                  _this4.inForm.provinceName = res[i].provinceName;
                  _this4.inForm.cityCode = res[i].cityCode;
                  _this4.inForm.cityName = res[i].cityName;
                  _this4.inForm.areaCode = res[i].areaCode;
                  _this4.inForm.areaName = res[i].areaName;
                }

                _this4.inForm.damageDate = res[i].damageDate;
                _this4.inForm.damagedItem = res[i].damagedItem;
                _this4.inForm.reportName = res[i].reportName;
                _this4.inForm.reportPhone = res[i].reportPhone;
                _this4.inForm.reportEmail = res[i].reportEmail;
                _this4.inForm.lossAmount = res[i].lossAmount;
                _this4.inForm.acciReason = res[i].acciReason;
                _this4.inForm.damageAddress = res[i].damageAddress;
                _this4.inForm.reportMethodCode = res[i].reportMethodName;
                _this4.inForm.acciReasonCode = res[i].acciReasonCode;
                _this4.inForm.currencyName = res[i].currencyName;
                _this4.inForm.detailAddress = res[i].detailAddress;
              }
            }
          });
        }
      }

      this.claimCode = this.inForm.claimCode = this.$route.params.claimCode ? this.$route.params.claimCode : '';
      this.claimCode = this.inForm.claimCode = this.claimCode == 'null' ? '' : this.claimCode;

      if (this.comeFlag == 'apply') {
        var data = {
          policyNo: policyNo,
          claimCode: this.claimCode,
          claimNo: '0'
        };
        this.from = '0';
      } else {
        debugger;
        var data = {
          policyNo: policyNo,
          claimNo: '1'
        };
        this.nationFlag = true;
        this.from = '1';
        LookNews_fun(data).then(function (res) {
          // this.tableData1.push(res)
          _this4.tableData2 = res.cargoListDto;

          if (_this4.tableData2.length > 0) {
            for (var i = 0; i < _this4.tableData2.length; i++) {
              _this4.currencyList = [];

              if (_this4.tableData2[i].invoicCurrencyCode == 'CNY') {
                var currency = {
                  "currencyCode": _this4.tableData2[i].invoicCurrencyCode,
                  "currencyName": _this4.tableData2[i].invoicCurrency
                };

                _this4.currencyList.push(currency);
              } else {
                var currencyCNY = {
                  "currencyCode": "CNY",
                  "currencyName": "人民币元 - CNY"
                };
                var _currency = {
                  "currencyCode": _this4.tableData2[i].invoicCurrencyCode,
                  "currencyName": _this4.tableData2[i].invoicCurrency
                };

                _this4.currencyList.push(_currency);

                _this4.currencyList.push(currencyCNY);
              }

              _this4.tableData2[i]["currencyList"] = _this4.currencyList;
              _this4.tableData2[i]["compensateCurrencyCode"] = "CNY";
              _this4.tableData2[i]["compensateCurrencyName"] = "人民币元 - CNY";
            }
          }

          if (res.singleness == '0') {
            _this4.getTips = '请上传事故照片、发票、提单、装箱单影像';
          } else {
            _this4.getTips = '请上传事故照片、发票影像件';
          }

          _this4.loing_box = false;
        });
      }

      if (this.comeFlag == 'claim' && this.type == 'edit') {
        this.inForm.countryEName = 'CHN';
        this.inForm.countryName = '中国';
      } // debugger
      // if(this.nationType=='1'){
      //   this.inForm.nationalFlag=this.nationType
      //   this.inForm.nationalFlagName='国内'
      // }else if(this.nationType=='2'){
      //   this.inForm.nationalFlag=this.nationType
      //   this.inForm.nationalFlagName='国外'
      // }else{
      //   this.inForm.nationalFlag=''
      //   this.inForm.nationalFlagName=''
      // }


      var type = this.$route.params.type; //初始化人身伤害信息

      debugger;
      var cliamCodeDate = {
        'claimCode': this.$route.params.claimCode
      };
      rinkoClaimPersonQuery(cliamCodeDate).then(function (res) {
        if (res != null) {
          debugger;
          _this4.personHurtInfo = res;
        }
      }); //初始化保单信息查询

      var policyData = {
        'policyNo': this.$route.params.policyNo
      };
      debugger;
      claimReportApplyQueryList(policyData).then(function (res) {
        if (res != null) {
          _this4.tableData1 = res;
          debugger;
          _this4.inForm.currencyCode = _this4.tableData1[0].currency;
          _this4.inForm.currencyName = _this4.tableData1[0].currencyName;
        }
      });
      this.loing_box = false;
    },
    base64ToFile: function base64ToFile(data, flie) {
      // 将base64 的图片转换成file对象上传 atob将ascii码解析成binary数据
      var binary = atob(data.split(',')[1]);
      var mime = data.split(',')[0].match(/:(.*?);/)[1];
      var array = [];

      for (var i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }

      var fileData = new Blob([new Uint8Array(array)], {
        type: mime
      });
      var file = new File([fileData], "".concat(new Date().getTime(), ".png"), {
        type: mime
      });
      return file;
    },
    look_img: function look_img(file) {
      if (file.fileSrc == undefined || file.fileSrc == "") {
        console.log("未上传到服务器");
        this.$message({
          message: '请检查该文件是否已经进行上传影像',
          type: 'warning'
        });
      } else {
        var data = {
          fileSrc: file.fileSrc
        };
        debugger;
        rinkoImageView(data).then(function (res) {
          var blob = new Blob([res], {
            type: ""
          });
          var url = window.URL.createObjectURL(blob);
          console.log(url);
          var link = document.createElement("a"); // 创建a标签

          link.href = url;
          link.download = file.name; // 重命名文件

          link.click();
          URL.revokeObjectURL(url); // 释放内存
        });
      }
    },
    // 提交图片信息--
    rinkoUploads: function rinkoUploads() {
      var _this5 = this;

      debugger;

      if (!this.isSave) {
        this.$message({
          message: '请先进行暂存操作',
          type: 'warning'
        });
        return;
      }

      this.flag = false;
      this.loing_box = true;
      var formData = new FormData();
      formData.append('policyNo', this.inForm.policyNo);
      formData.append('insuranceCompanyCode', this.inForm.insuranceCompanyCode);
      formData.append('insuranceCompanyName', this.inForm.insuranceCompanyName);
      formData.append('claimCode', this.inForm.claimCode);
      this.fileList = []; //debugger;
      //运输单证

      for (var i = 0; i < this.fileList1.length; i++) {
        this.fileList.push(this.fileList1[i]);
        this.fileListF = {};
        this.fileListF.imagUse = '5';
        this.fileListF.imagUseType = '10';
        this.fileListF.name = this.fileList1[i].name;
        this.fileListF.imagUseName = this.fileList1[i].imagUseName;
        this.fileListZ.push(this.fileListF);
      }

      formData.append('fileLis', JSON.stringify(this.fileListZ)); //影像列表

      if (this.fileList.length > 0) {
        var m = 0;
        var newarray = [];

        for (var _j = 0; _j < this.fileList.length; _j++) {
          var status = 0;

          for (var _i = 0; _i < this.fileList.length; _i++) {
            if (this.fileList[_j].name == this.fileList[_i].name) {
              status = status + 1;
            }

            if (status > 1) {
              this.$message({
                message: '上传文件名字有重复，请确认！ 重复文件名：' + this.fileList[_i].name,
                type: 'error'
              });
              this.loing_box = false;
              return;
            }
          }
        }

        for (var j = 0; j < this.fileList.length; j++) {
          if (this.fileList[j].raw && this.fileList[j].type != "old") {
            if (m < 10) {
              formData.append('files', this.fileList[j].raw);
              this.fileList[j]['type'] = 'old';
            }

            m++;
          }
        }

        rinkoImageUploads(formData).then(function (res) {
          //debugger;
          if (res.rtnCode == '0000') {
            _this5.isList1 = true;
            var k = 0;

            for (var i = 0; i < _this5.fileList.length; i++) {
              debugger;

              if (!_this5.fileList[i].imagCode && k < 10) {
                _this5.fileList[i].fileSrc = res.rinkoImageDetailList[k].fileSrc;
                _this5.fileList[i].imagCode = res.rinkoImageDetailList[k].imagCode;
                _this5.fileList[i].base64url = res.rinkoImageDetailList[k].base64Src;
                _this5.fileList[i].proposalNo = res.rinkoImageDetailList[k].proposalNo;
                _this5.fileList[i].claimCode = _this5.inForm.claimCode;
                newarray.push(_this5.fileList[i]);
                k++;
              }
            }

            ;
            console.log(newarray.length);

            if (newarray.length > 9) {
              _this5.rinkoImageUploads2();
            } else {
              $(".el-upload-list__item-status-label").css("display", "block");

              _this5.$message({
                message: res.data,
                type: 'success'
              });

              _this5.upimgsNum = _this5.fileList.length;
              _this5.isSave = true;
              _this5.isUpimg = true;
              _this5.loing_box = false;
              _this5.isList1 = true;
            }
          } else {
            _this5.$message({
              message: '没有待上传的影像',
              type: 'error'
            });

            _this5.loing_box = false;
          }
        }, function (res) {
          _this5.loing_box = false;
        });
      } else {
        this.$message({
          message: '没有待上传的影像',
          type: 'error'
        });
        this.loing_box = false;
      }
    },
    rinkoImageUploads2: function rinkoImageUploads2() {
      var _this6 = this;

      this.loing_box = true;

      if (this.fileList.length > 0) {
        var formData = new FormData();
        formData.append('policyNo', this.inForm.policyNo);
        formData.append('insuranceCompanyCode', this.inForm.insuranceCompanyCode);
        formData.append('insuranceCompanyName', this.inForm.insuranceCompanyName);
        formData.append('claimCode', this.inForm.claimCode);

        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].raw && this.fileList[i].type != "old") {
            formData.append('files', this.fileList[i].raw);
            this.fileList[i]['type'] = 'old';
          }
        }

        formData.append('fileLis', JSON.stringify(this.fileListZ));
        rinkoImageUploads(formData).then(function (res) {
          if (res.rtnCode == '0000') {
            $(".el-upload-list__item-status-label").css("display", "block");

            _this6.$message({
              message: res.data,
              type: 'success'
            });

            _this6.upimgsNum = _this6.fileList.length;
            _this6.isSave = true;
            _this6.isUpimg = true;
            var k = 0;

            for (var i = 0; i < _this6.fileList.length; i++) {
              if (!_this6.fileList[i].imagCode) {
                _this6.fileList[i].fileSrc = res.rinkoImageDetailList[k].fileSrc;
                _this6.fileList[i].imagCode = res.rinkoImageDetailList[k].imagCode;
                _this6.fileList[i].base64url = res.rinkoImageDetailList[k].base64Src;
                _this6.fileList[i].proposalNo = res.rinkoImageDetailList[k].proposalNo;
                _this6.fileList[i].claimCode = _this6.inForm.claimCode;
                k++;
              }
            }
          } else {
            _this6.$message({
              message: '没有待上传的影像',
              type: 'error'
            });
          }

          _this6.loing_box = false;
        }, function (res) {
          _this6.loing_box = false;
        });
      } else {
        this.$message({
          message: '没有待上传的影像',
          type: 'error'
        });
        this.loing_box = false;
      }
    },
    httpRequest: function httpRequest(data) {},
    // 图片上传成功后
    success_img1: function success_img1(response, file, fileList) {
      this.fileList1 = fileList;
    },
    // 图片删除时1
    handleRemove1: function handleRemove1(file, fileList) {
      var _this7 = this;

      var formData = new FormData();
      var objimg = {
        rinkoImageDetailDtoList: [{
          base64Src: file.base64url,
          claimCode: this.claimCode,
          fileName: file.name,
          fileSrc: file.fileSrc,
          imagCode: file.imagCode
        }]
      };
      rinkoImageDel(objimg).then(function (res) {
        _this7.fileList1 = fileList;
      });
    },
    // 图片上传时
    handlePictureCardPreview1: function handlePictureCardPreview1(file) {
      this.fileList1.push(file);
    },
    // 判断上传影像文件类型
    beforeUploadimg1: function beforeUploadimg1(file) {
      var isLt2M = file.size / 1024 / 1024 < 5;
      var isold = true;
      var isnumber = true; //判断文件名是否重复

      var count = 0;
      this.fileList1.forEach(function (item, idx) {
        if (idx > 19) {
          isnumber = false;
        }

        if (file.name == item.name) {
          count++;

          if (count == 1) {
            isold = true;
          }

          if (count === 2) {
            isold = false;
          }
        }
      });

      if (!isold) {
        this.$message({
          message: '上传文件已存在，请确认后重新上传!',
          type: 'warning'
        });
      }

      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 5MB!',
          type: 'warning'
        });
      }

      if (!isnumber) {
        this.$message({
          message: '最多支持上传20个文件!',
          type: 'warning'
        });
      }

      return isLt2M && isold && isnumber;
    },
    view_but2: function view_but2(type, row) {
      var params = {
        type: type,
        policyNo: row.row.policyNo
      }; // console.log(params.insurancecompanyCode)

      this.$router.push({
        path: "/rinkoPlatClaimReport/claimPolicyInfoBuLu/".concat(params.policyNo, "/").concat(params.type)
      });
    },
    // 确定
    submit_but: function submit_but(formName, type) {
      var _this8 = this;

      this.loing_box = true;
      this.inForm.personHurtInfo = this.personHurtInfo;
      var data = this.inForm;
      debugger;
      data.policyNo = this.$route.params.policyNo; // data.acciReasonCode = this.inForm.acciReason

      data.claimNo = this.from;

      if (this.comeFlag == 'apply') {
        data.claimCode = this.$route.params.claimCode ? this.$route.params.claimCode : '';
      } else {
        data.claimCode = this.inForm.claimCode;
      } // data.claimNo = this.inForm.claimCode
      // this.options_acciReason.forEach(item => {
      //   if (item.value == this.inForm.acciReasonCode) data.acciReason = item.label
      // })


      if (this.tableData2 != null && this.tableData2.length > 0) {
        for (var i = 0; i < this.tableData2.length; i++) {
          if (this.tableData2[i].invoicCurrencyCode != "CNY") {
            if (this.tableData2[i].invoicCurrencyCode == this.tableData2[i].compensateCurrencyCode) {
              this.tableData2[i].compensateCurrencyName = this.tableData2[i].invoicCurrency;
            } else {
              this.tableData2[i].compensateCurrencyName = "人民币元 - CNY";
            }
          } else {
            this.tableData2[i].compensateCurrencyName = "人民币元 - CNY";
          }
        }
      }

      data.cargoListDto = _toConsumableArray(this.tableData2);
      data.submitType = type;
      data.proposalNo = this.proposalNo;
      data.insuranceCompanyName = '中国太平洋财产保险股份有限公司上海分公司';
      data.insuranceCompanyCode = 'IC0030';

      if (type === '0') {
        rinkoClaimReportApplySubmit(data).then(function (res) {
          if (res.resultCode == '0000') {
            _this8.$message({
              message: "\u7406\u8D54\u7533\u8BF7\u5355\u53F7\uFF1A".concat(res.claimCode, "\uFF0C").concat(type == 1 ? '提交' : '暂存', "\u6210\u529F"),
              type: 'success'
            });

            data.claimCode = res.claimCode;
            _this8.isSave = true;
          } else {
            _this8.$message.error(res.resultMsg);
          }

          _this8.loing_box = false;
        });
      }

      debugger;

      if (type === '1') {
        debugger;

        if (this.fileList1.length > 0) {
          if (!this.isList1) {
            this.$message({
              message: '请先上传影像信息',
              type: 'error'
            });
            this.loing_box = false;
            return;
          }
        }

        this.$refs[formName].validate(function (valid) {
          console.log(valid);
          debugger;

          if (valid) {
            debugger;

            if (null != data.claimCode && "" != data.claimCode && "claim" != data.claimCode) {
              rinkoClaimReportApplySubmit(data).then(function (res) {
                debugger;

                if (res.resultCode == '0000') {
                  _this8.$message({
                    message: "\u7406\u8D54\u7533\u8BF7\u5355\u53F7\uFF1A".concat(res.claimCode, "\uFF0C").concat(type == 1 ? '提交' : '暂存', "\u6210\u529F"),
                    type: 'success'
                  });

                  _this8.$router.go('-1'); // 关闭导航栏


                  _this8.$store.dispatch('delVisitedViews', _this8.$route);
                } else {
                  _this8.$message.error(res.resultMsg);
                }

                _this8.loing_box = false;
              });
            } else {
              _this8.loing_box = false;

              _this8.$message({
                message: "\u8BF7\u5148\u70B9\u51FB\u6682\u5B58",
                type: 'warning'
              });
            }
          } else {
            _this8.$message.error('请完成必填项！');

            _this8.loing_box = false;
            return false;
          }
        }, function (res) {
          _this8.loing_box = false;
        });
      }
    },
    // 取消
    close_but: function close_but() {
      // 返回上一步路由
      this.$router.go(-1);
      this.$store.dispatch('delVisitedViews', this.$route);
    },
    // 报案方式
    reportMethodCode_ch: function reportMethodCode_ch(val) {
      this.inForm.reportMethodName = this.list_select(val, this.options_reportMethod);
    },
    // 出险原因
    acciReason_ch: function acciReason_ch(val) {
      // console.log(val)
      if (val != '99') {
        this.clearValidate('damageAddress');
      }

      console.log(this.options_acciReason);
      this.inForm.acciReason = this.list_select(val, this.options_acciReason); //debugger
    },
    // 下拉框通过code 获取 name值函数
    list_select: function list_select(val, list) {
      var obj = {};
      obj = list.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value == val; // 筛选出匹配数据
      });
      return obj.label;
    },
    list_selectName: function list_selectName() {
      var obj = {};
      obj = list.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value == val; // 筛选出匹配数据
      });
      return obj.value;
    },
    // 出险原因
    codeTypeList_fun: function codeTypeList_fun() {
      var _this9 = this;

      var data = {
        'codeLever': '1',
        'codeType': ['reportMethod', 'acciReason', 'country']
      };
      debugger;
      codeTypeList(data).then(function (res) {
        debugger;
        _this9.options_reportMethod = [];
        _this9.options_acciReason = [];
        _this9.countryList = [];

        for (var i = 0; i < res.length; i++) {
          if (res[i].codeType == 'reportMethod') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              debugger;
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this9.options_reportMethod.push(obj);
            }
          }

          if (res[i].codeType == 'acciReason') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.value = res[i].dictionary[k].codeCode;
              obj.label = res[i].dictionary[k].codeCname;

              _this9.options_acciReason.push(obj);
            }
          }

          if (res[i].codeType == 'country') {
            for (var k = 0; k < res[i].dictionary.length; k++) {
              var obj = {};
              obj.codeCode = res[i].dictionary[k].codeCode;
              obj.codeCname = res[i].dictionary[k].codeCname;

              if (obj.codeCname != '中国') {
                _this9.countryAllList.push(obj);
              }

              if (obj.codeCname == '中国') {
                _this9.chinaList.push(obj);

                _this9.countryList = _this9.chinaList;
              }
            }

            if (_this9.type == 'edit' && _this9.comeFlag == 'apply') {
              _this9.countryList = _this9.countryAllList;
            } else {
              _this9.countryList = _this9.chinaList;
            }
          }
        }
      });
    },
    getProvinceCityData: function getProvinceCityData() {
      var _this10 = this;

      //获取省市区数据
      getProvinceCityArea().then(function (res) {
        _this10.provinceList = [];
        _this10.allAddressData = res;

        for (var i = 0; i < res.length; i++) {
          if (res[i].codeType == 'insuredProvince') {
            var obj = {};
            obj.codeCode = res[i].codeCode;
            obj.codeCname = res[i].codeCname;

            _this10.provinceList.push(obj);
          }
        }
      });
    },
    nationFlagChange: function nationFlagChange() {
      //this.flag=true
      debugger;

      if (this.inForm.nationType == '2') {
        this.showFlag = false;
        this.nationFlag = false;
        this.countryList = [];
        this.countryList = this.countryAllList;
        this.inForm.countryEName = '';
        this.inForm.countryName = '';
        this.inForm.provinceCode = '';
        this.inForm.provinceName = '';
        this.inForm.cityCode = '';
        this.inForm.cityName = '';
        this.inForm.areaCode = '';
        this.inForm.areaName = '';
        this.inForm.detailAddress = '';
        this.inForm.nationalFlag = this.inForm.nationType;
        this.inForm.nationalFlagName = '国外';
      } else {
        this.nationFlag = true;
        this.showFlag = true;
        this.countryList = this.chinaList;
        this.inForm.countryEName = 'CHN';
        this.inForm.countryName = '中国';
        this.inForm.provinceCode = '';
        this.inForm.provinceName = '';
        this.inForm.cityCode = '';
        this.inForm.cityName = '';
        this.inForm.areaCode = '';
        this.inForm.areaName = '';
        this.inForm.detailAddress = "";
        this.inForm.nationalFlag = this.inForm.nationType;
        this.inForm.nationalFlagName = '国内';
      }
    },
    countryChange: function countryChange(val) {
      if (this.nationType == '1') {
        this.nationFlag = true;
      } else {
        this.nationFlag = false;
      }

      var countryArr = [];
      countryArr = val.split('-');
      this.inForm.countryEName = countryArr[0];
      this.inForm.countryName = countryArr[1];
    },
    provinceChange: function provinceChange(val) {
      this.flag = true;
      var provinceArr = [];
      provinceArr = val.split('-');
      this.inForm.provinceCode = provinceArr[0];
      this.inForm.provinceName = provinceArr[1];
      this.inForm.cityCode = '';
      this.inForm.cityName = '';
      this.inForm.areaCode = '';
      this.inForm.areaName = '';
      this.cityList = [];

      for (var i = 0; i < this.allAddressData.length; i++) {
        if (this.allAddressData[i].codeCode == provinceArr[0]) {
          for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            var obj = {};
            obj.codeCode = this.allAddressData[i].children[j].codeCode;
            obj.codeCname = this.allAddressData[i].children[j].codeCname;
            this.cityList.push(obj);
          }
        }
      }
    },
    cityChange: function cityChange(val) {
      this.flag = true;
      this.inForm.cityCode = val;
      this.areaList = [];
      var cityArr = [];
      cityArr = val.split('-');
      this.inForm.cityCode = cityArr[0];
      this.inForm.cityName = cityArr[1];
      this.inForm.areaCode = '';
      this.inForm.areaName = '';

      for (var i = 0; i < this.allAddressData.length; i++) {
        if (this.allAddressData[i].codeCode == this.inForm.provinceCode) {
          for (var j = 0; j < this.allAddressData[i].children.length; j++) {
            if (this.allAddressData[i].children[j].codeCode == cityArr[0]) {
              for (var k = 0; k < this.allAddressData[i].children[j].children.length; k++) {
                var obj = {};
                obj.codeCode = this.allAddressData[i].children[j].children[k].codeCode;
                obj.codeCname = this.allAddressData[i].children[j].children[k].codeCname;
                this.areaList.push(obj);
              }
            }
          }
        }
      }
    },
    areaChange: function areaChange(val) {
      this.inForm.areaCode = val;
      var areaArr = [];
      areaArr = val.split('-');
      this.inForm.areaCode = areaArr[0];
      this.inForm.areaName = areaArr[1];
    },
    detailAddressCheck: function detailAddressCheck(val) {
      console.log(1234);
      var temp = 0;
      var reg = /[\s\S]/g;
      var resultn = val.match(reg);

      for (var i = 0; i < resultn.length; i++) {
        if (/[\u4e00-\u9fa5]/.test(resultn[i])) {
          temp += 3;
        } else {
          temp += 3;
        }

        if (temp > 250) {
          this.$message({
            message: '详细地址最多支持输入250个字符(约82个汉字)',
            type: 'warning'
          });
          this.inForm.detailAddress = val.substring(0, i);
          break;
        }
      }
    },
    //添加人身伤害信息
    add_personHurt: function add_personHurt() {
      var length = this.personHurtInfo.length;
      var obj = {
        serialNo: length + 1,
        peopleName: '太保小明',
        hurtDisease: '',
        hostpitalName: '',
        remark: ''
      };
      this.personHurtInfo.push(obj);
      console.log(this.personHurtInfo);
    },
    del_personHurt: function del_personHurt(index) {
      this.personHurtInfo.splice(index, 1);
      var length = this.personHurtInfo.length;

      for (var k = 0; k < length; k++) {
        this.personHurtInfo[k].serialNo = k + 1;
      }
    }
  }
};